var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseComponent } from "../../../../common/components/base.component";
import { HubApiService } from 'services/hub.api.service';
import { ActivatedRoute } from '@angular/router';
import { AssignTourModalActions, AssignTourModalData } from "../../assign.tour.modal/assign.tour.modal.provider";
import { AssignTourModalComponent } from "../../assign.tour.modal/assign.tour.modal.component";
import { EditCityModalActions } from "../../edit.city.modal/edit.city.modal.provider";
import { EditCityModalComponent } from "../../edit.city.modal/edit.city.modal.component";
import { HubFeed } from "../../../../models/hub/hub.feed";
import { HubComponent } from "../../hub.component";
import { AlertifyService } from "../../../../services/alertify.service";
import { ModalService } from "../../../../common/services/modal.service";
import { AddCityModalActions, AddCityModalData } from "../../add.city.modal/add.city.modal.provider";
import { AddCityModalComponent } from "../../add.city.modal/add.city.modal.component";
import { ConfirmModalActions, ConfirmModalData } from "../../../../common/components/confirm.modal/confirm.modal.provider";
import { ConfirmModalComponent } from "../../../../common/components/confirm.modal/confirm.modal.component";
import { HubFacebookLocationFeedsStore } from "../../../../stores/hub.calendar.store";
import { Observable } from "rxjs/Observable";
import { isNullOrUndefined } from "util";
import { VisitorApiService } from "../../../../services/visitor.api.service";
var RegionComponent = /** @class */ (function (_super) {
    __extends(RegionComponent, _super);
    function RegionComponent(hubApiService, formBuilder, parent, alertify, modalService, visitorApiService, hubFacebookLocationFeedsStore, activatedRoute) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.hubApiService = hubApiService;
        _this.formBuilder = formBuilder;
        _this.parent = parent;
        _this.alertify = alertify;
        _this.modalService = modalService;
        _this.visitorApiService = visitorApiService;
        _this.hubFacebookLocationFeedsStore = hubFacebookLocationFeedsStore;
        _this.activatedRoute = activatedRoute;
        _this.hubName = null;
        _this.isCreatingRegion = false;
        _this.isEditRegion = [];
        _this.isLoadingFeeds = false;
        _this.featuresToggle = {
            tripPlanner: false,
            multipleCities: false,
        };
        _this.multiCities = {
            active: false,
            cityBlock: {
                active: true
            },
            regions: [],
            tours: []
        };
        _this.placeSource = 'google';
        return _this;
    }
    RegionComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.parent.location = 'Trip Planner';
        this.form = this.formBuilder.group({
            regionName: [null, []],
        });
        this.hubFacebookLocationFeedsStore.locationCommand
            .takeUntil(this.isDestroyed)
            .subscribe(function (hubLocations) {
            _this.hubLocations = hubLocations.hubPages;
            _this.hubLocations = (_this.hubLocations && _this.hubLocations.length) ? _this.hubLocations.filter(function (x) { return x.socialName === _this.placeSource; }) : [];
            _this.setHubLocations();
        });
        if (!this.hubLocations || !this.hubLocations.length) {
            this.getHubLocations();
        }
        this.visitorApiService.getToggles(this.hubName).subscribe(function (toggle) {
            if (toggle) {
                _this.featuresToggle.tripPlanner = isNullOrUndefined(toggle.tripPlanner) ? true : toggle.tripPlanner;
                _this.featuresToggle.multipleCities = !!toggle.multipleCities;
                _this.multiCities.active = _this.featuresToggle.multipleCities;
                if (_this.multiCities.active) {
                    _this.hubApiService.getCityBlockToggle(_this.hubName).subscribe(function (block) {
                        _this.multiCities.cityBlock.active = !isNullOrUndefined(block.active) ? block.active : true;
                    });
                }
            }
        });
        this.visitorApiService.getDataSource(this.hubName).subscribe(function (dataSource) {
            if (dataSource) {
                _this.placeSource = dataSource.place;
            }
        });
        this.getRegions();
        this.getTours();
    };
    RegionComponent.prototype.toggleMultipleCities = function () {
        var _this = this;
        this.hubApiService.toggleMultipleCities(this.hubName, this.multiCities.active).subscribe(function () {
            _this.alertify.successfully("Turn the regions feature " + (_this.multiCities.active ? 'on' : 'off'));
        });
    };
    RegionComponent.prototype.toggleCityBlock = function () {
        var _this = this;
        this.hubApiService.toggleCityBlock(this.hubName, this.multiCities.cityBlock.active).subscribe(function () {
            _this.alertify.successfully("Turn the city block " + (_this.multiCities.cityBlock.active ? 'on' : 'off'));
        });
    };
    RegionComponent.prototype.editRegion = function (region, index) {
        this.isEditRegion[index] = true;
    };
    RegionComponent.prototype.updateRegionName = function ($event, region, index) {
        var _this = this;
        this.hubApiService.updateRegionName(this.hubName, { id: region.id, name: region.name })
            .finally($event.complete)
            .subscribe(function (data) {
            _this.isEditRegion[index] = false;
            _this.alertify.successfully('Update the region name');
        });
    };
    RegionComponent.prototype.deleteRegion = function (region) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService.deleteRegion(_this.hubName, region.id)
                    .finally(event.complete).subscribe(function (data) {
                    var newRegions = [];
                    _this.multiCities.regions.forEach(function (x) {
                        if (x.id !== region.id) {
                            newRegions.push(x);
                        }
                    });
                    _this.multiCities.regions = newRegions;
                    _this.alertify.successfully('Delete the region');
                });
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove delete this region?",
            confirmModalConfirmButtonText: 'Delete',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    RegionComponent.prototype.removeCityFromRegion = function (region, city) {
        var _this = this;
        var actions = {
            confirm: function (event) {
                _this.hubApiService.removeCityFromRegion(_this.hubName, region.id, city.id)
                    .finally(event.complete).subscribe(function (data) {
                    //let index = region.cities.getElementIndex(x => x.id === city.id);
                    //region.cities = region.cities.splice(index, 1);
                    var newCities = [];
                    region.cities.forEach(function (x) {
                        if (x.id !== city.id) {
                            newCities.push(x);
                        }
                    });
                    region.cities = newCities;
                });
            }
        };
        var data = {
            confirmModalIcon: 'warning',
            confirmModalTitle: 'Alert',
            confirmModalDescription: "Are you sure you want to remove \"" + (city.cityTitle || city.title) + "\" from this region?",
            confirmModalConfirmButtonText: 'Remove',
            confirmModalCancelButtonText: 'Cancel',
            isAsync: true
        };
        this.modalService.show({
            component: ConfirmModalComponent,
            providers: [
                { provide: ConfirmModalActions, useValue: actions },
                { provide: ConfirmModalData, useValue: data }
            ]
        });
    };
    RegionComponent.prototype.loadCities = function (region) {
        var _this = this;
        if (region) {
            var cities_1 = [];
            region.cities.forEach(function (city) {
                var c = _this.hubLocations.filter(function (x) { return x.socialName === _this.placeSource; }).first(function (x) { return x.id === city.id; });
                if (c) {
                    city.cityTitle = c.cityTitle;
                    city.title = c.title;
                    cities_1.push(city);
                }
            });
            region.cities = cities_1;
        }
        else {
            this.multiCities.regions.forEach(function (region) {
                var cities = [];
                region.cities.forEach(function (city) {
                    var c = _this.hubLocations.first(function (x) { return x.id === city.id; });
                    if (c) {
                        city.cityTitle = c.cityTitle;
                        city.title = c.title;
                        cities.push(city);
                    }
                });
                region.cities = cities;
            });
        }
    };
    RegionComponent.prototype.addCity = function (region) {
        var _this = this;
        var actions = {
            confirm: function (event, addedCityIds) {
                var obj = [];
                addedCityIds.forEach(function (x) {
                    obj.push({ id: x });
                });
                (_a = region.cities).push.apply(_a, obj);
                _this.loadCities(region);
                _this.alertify.successfully('Add the cities');
                var _a;
            }
        };
        var locationFeeds = [];
        this.hubLocations.forEach(function (x) {
            var isInRegion = false;
            region.cities.forEach(function (y) {
                if (y.id === x.id) {
                    isInRegion = true;
                }
            });
            if (!isInRegion) {
                locationFeeds.push({ locationFeed: x, isInRegion: isInRegion });
            }
        });
        this.modalService.show({
            component: AddCityModalComponent,
            providers: [
                { provide: AddCityModalActions, useValue: actions },
                {
                    provide: AddCityModalData,
                    useValue: new AddCityModalData(this.hubName, region.id, this.hubLocations.length === 0, locationFeeds)
                }
            ]
        });
    };
    RegionComponent.prototype.enterAssignTour = function (tour) {
        var _this = this;
        var actions = {
            confirm: function (event, data) {
                _this.getRegions();
                _this.alertify.successfully('Assign the itinerary');
            }
        };
        var regions = [];
        this.multiCities.regions.forEach(function (x) {
            var isInRegion = false;
            x.tours.forEach(function (y) {
                if (y.id === tour._id) {
                    isInRegion = true;
                }
            });
            regions.push({ region: x, isInRegion: isInRegion });
        });
        this.modalService.show({
            component: AssignTourModalComponent,
            providers: [
                { provide: AssignTourModalActions, useValue: actions },
                {
                    provide: AssignTourModalData,
                    useValue: new AssignTourModalData(this.hubName, tour._id, regions)
                },
            ],
        });
    };
    RegionComponent.prototype.enterEditCity = function (feed) {
        var _this = this;
        var actions = {
            confirm: function (event, data) {
                if (data.image) {
                    feed.cityImage = data.image;
                }
                feed.cityTitle = data.cityTitle;
                _this.alertify.successfully('Update the city');
                _this.hubApiService.getLocationFeeds(_this.hubName).subscribe(function (data) {
                    _this.hubLocations = data.filter(function (x) { return x.socialName === _this.placeSource; });
                    _this.setHubLocations();
                    _this.loadCities();
                });
            }
        };
        feed.hubName = this.hubName;
        this.modalService.show({
            component: EditCityModalComponent,
            providers: [
                { provide: EditCityModalActions, useValue: actions },
                { provide: HubFeed, useValue: feed },
            ],
        });
    };
    RegionComponent.prototype.addNewRegion = function () {
        var _this = this;
        this.isCreatingRegion = true;
        var command = { name: 'New Region', cities: [], id: '', tours: [] };
        this.hubApiService.createRegion(this.hubName, command).subscribe(function (regionId) {
            command.id = regionId;
            _this.multiCities.regions.push(command);
            _this.isCreatingRegion = false;
        });
    };
    RegionComponent.prototype.setHubLocations = function () {
        this.hubLocations && this.hubLocations.forEach(function (x) {
            x.cityTitle = x.cityTitle || x.title;
        });
    };
    RegionComponent.prototype.getRegions = function () {
        var _this = this;
        this.hubApiService.getRegions(this.hubName).subscribe(function (data) {
            _this.multiCities.regions = data;
            _this.isEditRegion = [];
            _this.multiCities.regions.forEach(function (x) {
                _this.isEditRegion.push(false);
            });
        });
    };
    RegionComponent.prototype.getTours = function () {
        var _this = this;
        this.hubApiService.getTours(this.hubName)
            .subscribe(function (data) {
            _this.multiCities.tours = data;
        });
    };
    RegionComponent.prototype.getHubLocations = function () {
        var _this = this;
        var times = 0;
        this.isLoadingFeeds = true;
        var getFeeds = function () { return _this.hubApiService.getLocationFeeds(_this.hubName)
            .catch(function (err) {
            if (times < 3) {
                getFeeds();
            }
            times++;
            return Observable.throw(err.statusText);
        })
            .subscribe(function (data) {
            _this.isLoadingFeeds = false;
            _this.hubLocations = data;
            _this.hubLocations = (_this.hubLocations && _this.hubLocations.length) ? _this.hubLocations.filter(function (x) { return x.socialName === _this.placeSource; }) : [];
            _this.setHubLocations();
        }); };
        getFeeds();
    };
    return RegionComponent;
}(BaseComponent));
export { RegionComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/tours/regions/region.component.ts.pre-build-optimizer.js